module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/2.9.3-62.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/2.9.3.md
// module id = 479
// module chunks = 475